import { ofType } from 'redux-observable';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { EMPTY, from, of, concat, defer, iif, debounceTime } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_INCARICO_LIST } from '../../data.const';
import {
  setListConfigAction,
  setLoaders,
  setPopupInfo,
  storeIncaricoListAction,
} from '../../data.action';
import { filler } from '../../../../../utils/utils';
import { selectIncaricoList } from '../../data.selector';

const retrieveIncaricoListEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_INCARICO_LIST),
    debounceTime(20),
    map(({ payload }: any) => payload),
    // tap(p => console.log(`[epic ${RETRIEVE_INCARICO_LIST}]`, p)),
    withLatestFrom(state$),
    switchMap(([body, state]) => {
      return concat(
        of(setLoaders({ incaricoLoader: true })),
        iif(
          () => body?.pageSize <= 100,
          of(setListConfigAction({ incarico: body })),
          EMPTY
        ),
        defer(() =>
          from(
            request({
              path: `incarico/list`,
              method: httpMethods.POST,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }

              // lazy load
              if (body?.append) {
                const currentList = selectIncaricoList(state)?.result;
                return {
                  total: p?.total,
                  result: [...(currentList ?? []), ...p?.result],
                };
              }

              return {
                total: p?.total,
                result: [...p?.result, ...filler],
              };
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_INCARICO_LIST}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(data => of(storeIncaricoListAction(data))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_INCARICO_LIST}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ incaricoLoader: false }))
      );
    })
  );

export default retrieveIncaricoListEpic;
